import { AddressTypeType, StoreTypeType } from "database";

export type Address = {
  id: string;
  teamId: string;
  addressType: AddressTypeType;
  zipCode: string;
  addressLine: string;
  number: string;
  district: string;
  city: string;
  state: string;
  country: string;
  latitude?: number | null;
  longitude?: number | null;
};

export type SellerDto = {
  id: string;
  name: string;
  avatarUrl?: string | null;
  storeType: StoreTypeType;
  cgcNumber?: string | null;
  businessName?: string | null;
  phone1?: string | null;
  phone2?: string | null;
  addresses?: Address[];
  slug: string;
};

export enum SellerAddressType {
  STOREFRONT = "STOREFRONT",
  FINANCIAL = "FINANCIAL",
}
